__turbopack_context__.v({
  "agentBlue": "onboardingIntroWalkthrough-module__7ncr5W__agentBlue",
  "agentBlueDrift": "onboardingIntroWalkthrough-module__7ncr5W__agentBlueDrift",
  "animateSelect": "onboardingIntroWalkthrough-module__7ncr5W__animateSelect",
  "animateTrack": "onboardingIntroWalkthrough-module__7ncr5W__animateTrack",
  "caretBlink": "onboardingIntroWalkthrough-module__7ncr5W__caretBlink",
  "edgeFadeY": "onboardingIntroWalkthrough-module__7ncr5W__edgeFadeY",
  "outlineSparkleRing": "onboardingIntroWalkthrough-module__7ncr5W__outlineSparkleRing",
  "typedCaret": "onboardingIntroWalkthrough-module__7ncr5W__typedCaret",
  "typedChar": "onboardingIntroWalkthrough-module__7ncr5W__typedChar",
  "typedLine": "onboardingIntroWalkthrough-module__7ncr5W__typedLine",
});
